import { useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Copy, Check } from "lucide-react";
import { useLang } from "../i18n";

export default function Contact() {
  const { t } = useLang();
  const [copied, setCopied] = useState(false);
  const email = "max.dhumerelle@gmail.com";

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {}
  };

  return (
    <div data-testid="contact-page" className="pt-16 min-h-screen flex flex-col">
      <section className="flex-1 px-6 sm:px-12 lg:px-20 py-24 lg:py-32 flex flex-col justify-center">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="font-mono-meta text-xs uppercase tracking-[0.25em] text-[#C83E2B] mb-8"
        >
          {t("contact.kicker")}
        </motion.p>
        <div className="overflow-hidden mb-6">
          <motion.h1
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="font-serif-display font-light text-[13vw] lg:text-8xl leading-[0.95]"
            data-testid="contact-title"
          >
            {t("contact.title")}
          </motion.h1>
        </div>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="text-base text-[#5A5853] max-w-md leading-relaxed mb-20"
          data-testid="contact-sub"
        >
          {t("contact.sub")}
        </motion.p>

        <div className="border-t" style={{ borderColor: "#E5E2DC" }}>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.45, duration: 0.7 }}
            className="py-10 border-b flex flex-wrap items-center gap-6 group"
            style={{ borderColor: "#E5E2DC" }}
          >
            <span className="font-mono-meta text-[11px] uppercase tracking-[0.2em] text-[#8C8983] w-28">
              {t("contact.email_label")}
            </span>
            <a
              href={`mailto:${email}`}
              data-testid="contact-email-link"
              className="font-serif-display italic text-2xl sm:text-4xl link-line break-all"
            >
              {email}
            </a>
            <button
              data-testid="contact-copy-btn"
              onClick={copy}
              className="ml-auto inline-flex items-center gap-2 font-mono-meta text-[11px] uppercase tracking-[0.18em] border border-[#C5C0B7] px-4 py-2 hover:bg-[#121212] hover:text-[#FAF9F6] hover:border-[#121212] transition-colors"
            >
              {copied ? <Check size={13} /> : <Copy size={13} />}
              {copied ? t("contact.copied") : t("contact.copy")}
            </button>
          </motion.div>

          <motion.a
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.7 }}
            href="https://instagram.com/Max.dhum"
            target="_blank"
            rel="noreferrer"
            data-testid="contact-instagram-link"
            className="py-10 border-b flex flex-wrap items-center gap-6 group"
            style={{ borderColor: "#E5E2DC" }}
          >
            <span className="font-mono-meta text-[11px] uppercase tracking-[0.2em] text-[#8C8983] w-28">
              {t("contact.ig_label")}
            </span>
            <span className="font-serif-display italic text-2xl sm:text-4xl link-line">@max.dhum</span>
            <span className="ml-auto inline-flex items-center gap-2 font-mono-meta text-[11px] uppercase tracking-[0.18em] text-[#8C8983] group-hover:text-[#121212] transition-colors">
              {t("contact.ig_cta")}
              <ArrowUpRight size={14} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </span>
          </motion.a>
        </div>
      </section>
    </div>
  );
}
